import { render, staticRenderFns } from "./ManageClientsContainer.vue?vue&type=template&id=62a5b3ce&scoped=true&"
import script from "./ManageClientsContainer.vue?vue&type=script&lang=js&"
export * from "./ManageClientsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a5b3ce",
  null
  
)

export default component.exports